import React, {useEffect, useState} from "react";
import {getUserFromJWT, validateJWT} from "../../service/blended_wizportal";
import {useHistory, useParams} from "react-router-dom";
import {loginManager} from "../../service/service";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import {reportAuthFailure, reportConsumer} from "../../helpers/newrelic";

export function EmbeddableExercisesPage () {

    const {setEmbedMode} = useAppGlobalConfig();

    const { jwt } = useParams();

    const history = useHistory();
    const [userInfo, setUserInfo] = useState(null);
    const [authError, setAuthError] = useState(false);

    useEffect(() => {
        async function doLogin() {
            try {

               const {token, user} =
                   await loginManager({jwtToken: jwt}, validateJWT, (d) => {
                        return Promise.resolve(getUserFromJWT(jwt))
                   })

                if (user) {
                    reportConsumer(user);
                    setUserInfo(user);
                    setEmbedMode(true);
                } else {
                    console.error('Token verification failed');
                    reportAuthFailure(jwt, new Error('Token verification failed'));
                    setAuthError(true);
                }
            } catch (err) {
                console.error('Error validating token:', err);
                reportAuthFailure(jwt, err);
                setAuthError(true);
            }
        }

        doLogin().then(() => {
            console.log('Login done');
        });

    }, [jwt]);  // Add 'jwt' to the dependency array

    useEffect(() => {
        if(userInfo) {
            const lessonId = userInfo.lesson_id;

            const location = `/embeddable/catchupId/1/lesson/${lessonId}/0`;
            history.push(location);
        }
    } , [userInfo]);

    if(authError) {
        return (
            <div className="card" style={{marginBottom: 50, border: "none", background: 'none'}}>
                <div className="home-no-lessons">
                    Authentication error.
                </div>
            </div>
        )
    }

    return (
      <div className="card" style={{marginBottom: 50, border: "none", background: 'none'}}>
          <div className="loading-lessons-container">
              <div className="spinner-border home-loading" role="status">
                  <span className="sr-only">Loading...</span>
              </div>
              <div style={{color: 'rgb(117,117,117)'}}>
                 Loading...
              </div>
          </div>
      </div>
    );
}